import classcat from "classcat";
import React from "react";
import Drawer from "react-modern-drawer";

import { IconArrowLeft } from "@touchtech/web-baselayer-ui";

import css from "./ExternalPageDrawer.module.css";

type Props = {
  handleClose: () => void;
  src?: string;
};

const DRAWER_Z_INDEX = 120;

const ExternalPageDrawer = ({ handleClose, src }: Props) => {
  return (
    <Drawer
      open
      size="100vh"
      onClose={() => {}}
      direction="bottom"
      enableOverlay={false}
      duration={0}
      style={{ zIndex: DRAWER_Z_INDEX }}
    >
      <div className={css.wrapper}>
        <button
          className={classcat(["text-headline-3xl", css.backContainer])}
          onClick={handleClose}
        >
          <IconArrowLeft />
        </button>
        <iframe className={css.iframe} src={src} allowFullScreen />
      </div>
    </Drawer>
  );
};

export default ExternalPageDrawer;
